{
  "WORK_ORDER": {
    "TITLE": "Work Order Form",
    "PROJECT": "Project",
    "SHARE": "Share",
    "ORDER_FORM": {
      "SUBMIT": "Send for review",
      "SUBMIT_SUCCESS": "Successfully updated the answers",
      "SUBMIT_ERROR": "Error updating the answers",
      "ADDITIONAL_INFORMATION": "Additional information",
      "GET_SUBMISSION_ERROR": "There was an error loading latest form submission",
      "UNSAVED_CHANGES": "You have unsaved changes",
      "UNSAVED_WARNING": "The changes you've made won't be saved if you leave this page",
      "LEAVE": "Leave without saving",
      "STAY": "Continue editing"
    },
    "COMMENTS": {
      "SUBMIT_SUCCESS": "Comment submitted.",
      "SUBMIT_ERROR": "Error adding comment, please try again later."
    }
  },
  "SALES_ORDER_SUMMARY": {
    "TITLE": "Work orders",
    "TITLE_NON_VENDOR": "Fulfillment",
    "THERMOMETER_SUFFIX": "{{completed}}/{{total}} complete"
  },
  "DISPLAYED_STATUS_VALUES": {
    "PENDING": "Pending",
    "ON_HOLD": "On hold",
    "IN_PROGRESS": "In progress",
    "IN_REVIEW": "In review",
    "VENDOR_REVIEW": "Vendor review",
    "FULFILLED": "Fulfilled",
    "CANCELED": "Canceled",
    "DETAILS_NEEDED": "Details needed",
    "COMPLETED": "Completed"
  },
  "PERSONA_STATUS_VALUES": {
    "PENDING": {
      "CP": "Action required",
      "VENDOR": "Waiting on customer",
      "SMB": "Action required",
      "SALES": "Action required"
    },
    "ACTION_REQUIRED": {
      "CP": "Pending",
      "VENDOR": "Action required",
      "SMB": "Pending",
      "SALES": "Pending"
    },
    "IN_REVIEW": {
      "CP": "Under review",
      "VENDOR": "Under review",
      "SMB": "Under review",
      "SALES": "Under review"
    },
    "IN_PROGRESS": {
      "CP": "In progress",
      "VENDOR": "In progress",
      "SMB": "In progress",
      "SALES": "In progress"
    },
    "FULFILLED": {
      "CP": "Completed",
      "VENDOR": "Completed",
      "SMB": "Completed",
      "SALES": "Completed"
    },
    "CANCELED": {
      "CP": "Canceled",
      "VENDOR": "Canceled",
      "SMB": "Canceled",
      "SALES": "Canceled"
    },
    "ON_HOLD": {
      "CP": "On hold",
      "VENDOR": "On hold",
      "SMB": "On hold",
      "SALES": "On hold"
    },
    "DECLINED": {
      "CP": "Declined",
      "VENDOR": "Declined",
      "SMB": "Declined",
      "SALES": "Declined"
    }
  },
  "CONTEXT": {
    "ACCOUNT_DELETED": "Account deleted",
    "TITLE": "Customer",
    "PHONE": "Phone number"
  },
  "LANDING_PAGE": {
    "DATE_CARD": {
      "TITLE": "Dates",
      "SUBMITTED": "Submitted",
      "UPDATED": "Updated"
    },
    "ORDER_INFO_CARD": {
      "TITLE": "Order details",
      "TITLE_NON_VENDOR": "Item details",
      "SUBMITTED_BY": "Submitted by",
      "CANCELLED": "Order canceled",
      "ACCOUNT": "Account",
      "PRODUCT": "Product",
      "PRICING": "Pricing",
      "FREE": "Free",
      "SALES_ORDER_ID": "Sales Order ID",
      "SALES_ORDER_ID_NON_VENDOR": "Order ID",
      "PRODUCT_STATUS": "Product status",
      "LOWERCASE_ITEM": "item",
      "LOWERCASE_ITEMS": "items",
      "QUANTITY": "(Qty {{quantity}})",
      "REASON": "Reason",
      "CANCELED_TEXT": "Product had a cancellation request sent on {{day}} at {{time}} by {{sourceIdentifier}}",
      "DEACTIVATED_TEXT": "Product was deactivated on {{day}} at {{time}} by {{sourceIdentifier}}",
      "REJECTED_TEXT": "Product activation was rejected."
    },
    "PRODUCT_STATUSES": {
      "PENDING_ACTIVATION": "Pending Activation",
      "ACTIVE": "Active",
      "REJECTED": "Rejected",
      "CANCELED": "Canceled",
      "DEACTIVATED": "Deactivated"
    },
    "COMMUNICATION_DETAILS": {
      "CONTACT": "Contact (Customer)",
      "SALESPERSON": "Salesperson",
      "COMMUNICATION_DETAILS": "Communication details"
    },
    "BANNER": {
      "TITLE": "Action required",
      "SUBTITLE": "Fulfillment form responses needed",
      "VIEW": "View"
    },
    "UNDER_REVIEW_BANNER": {
      "TITLE": "Under review",
      "SUBTITLE_MAIN_PAGE": "You will be notified if any more details are needed",
      "SUBTITLE_FULFILLMENT_PAGE": "You wll be notified if any more details are needed before we can start fulfillment"
    },
    "FORM_SUBMITTED_BANNER": {
      "TITLE": "Submitted",
      "SUBTITLE": "Your responses have been submitted and wil be reviewed shortly"
    }
  },
  "FULFILLMENT": {
    "TITLE": "Fulfillment"
  },
  "CHECKLIST": {
    "TITLE": "Checklist",
    "TOOLTIP_TEXT": "Click on any of the fields in the checklist to automatically scroll to the corresponding form"
  },
  "FORM_V2": {
    "SUBMIT_FORM": "Submit form",
    "SAVE_PROGRESS": "Save progress",
    "SAVE_CHANGES": "Save changes",
    "SUBMIT_SUCCESS": "Successfully submitted the form. It may take a few minutes for the changes to reflect in the system.",
    "SUBMIT_ERROR": "There was an error submitting the form",
    "SAVE_PROGRESS_SUCCESS": "Successfully saved progress",
    "SAVE_PROGRESS_ERROR": "There was an error saving progress",
    "SAVE_PROGRESS_ERROR_INVALID": "Cannot save progress as the fields you have entered are invalid.",
    "EMPTY_STATE_MESSAGE": "There is no fulfillment form associated with this work order",
    "RESTORE_ANSWERS": "Restore answers",
    "CONFLICT_DIALOG": {
      "TITLE": "Form submission conflicts",
      "MESSAGE": "Another user has made changes to the form. You must refresh the page before you can submit updates.",
      "SUB_MESSAGE": "You will have the option to restore your previous answers.",
      "CLOSE": "Close",
      "REFRESH": "Refresh"
    },
    "SUBMISSION_ERROR_DIALOG": {
      "TITLE": "Missing Information",
      "CONTENT": "Some required questions still need responses before you can submit this form.",
      "OK": "OK"
    },
    "SUBMISSION_CONFIRM_DIALOG": {
      "TITLE": "Submit form?",
      "CONTENT": "The fulfillment team will be notified once you submit your form.",
      "SUBMIT": "Submit",
      "CANCEL": "Cancel"
    },
    "LAST_UPDATED": "Last updated at {{timestamp}}"
  },
  "SLIDING_NOTIFIER": {
    "TITLE": "Action required on your order",
    "CONTENT": "order needs more information before fulfillment can begin on",
    "ITEMS": "items",
    "ITEM": "item",
    "DISMISS": "Dismiss",
    "VIEW_ORDER": "View order"
  },
  "PENDING_APPROVALS_CARD": {
    "TITLE": "Pending approvals",
    "DECLINE": "Decline",
    "APPROVE": "Approve",
    "CANCEL": "Cancel",
    "APPROVE_ORDER_DIALOG": {
      "TITLE": "Approve order",
      "CONTENT": "This will approve all recurring billing for this product going forward and allow fulfillment to proceed"
    },
    "DECLINE_ORDER_DIALOG": {
      "TITLE": "Decline order",
      "CONTENT": "This will cancel the order and immediately refund the reseller the initial payment for this product",
      "PROVIDE_A_REJECTION_REASON": "Provide a rejection reason"
    },
    "APPROVE_SUCCESS": "Successfully approved pending activation",
    "APPROVE_ERROR": "There was an error approving the pending activation",
    "DECLINE_SUCCESS": "Successfully declined pending activation",
    "DECLINE_ERROR": "There was an error declining the pending activation"
  },
  "SHARE": {
    "NO_USERS_TOOLTIP": "To share fulfillment form, create a user on the account",
    "SHARE_FORM": "Share form",
    "ADD_OR_SELECT_USERS": "Add or select users",
    "EMAIL_ADDRESSES": "Email addresses",
    "ADD_USERS": "Add users to account",
    "CANCEL": "Cancel",
    "SHARE": "Share",
    "PERSONALIZE": "Personalize the email with a brief message",
    "ADD_USER": "Add user"
  }
}
